export default __webpack_public_path__ + "static/media/user-placeholder.7fd2b880.png";